export const agreementKeys = {
  all: ['agreements'] as const,
  list: () => [...agreementKeys.all, 'list'] as const,
  detail: (uuid: string) => [...agreementKeys.all, 'detail', uuid] as const,
} as const;
